import React, { useState } from 'react';
import {
  TextField,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Button,
  IconButton,
  FormHelperText
} from '@mui/material';
import { Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';


export const CodeMappingTable = ({
  value,
  onChange,
  codeLabel,
  nameLabel,
  codePlaceholder,
  namePlaceholder
}) => {
  const [rows, setRows] = useState(() =>
    Object.entries(value || {}).map(([code, name]) => ({ code, name }))
  );

  const save = (nextRows) => {
    setRows(nextRows);
    const entries = nextRows
      .filter((row) => row.code.trim() !== '')
      .map((row) => [row.code.trim(), row.name]);
    onChange(entries.length > 0 ? Object.fromEntries(entries) : undefined);
  };

  const setRowField = (i, field, newValue) =>
    save(rows.map((row, index) => (index === i ? { ...row, [field]: newValue } : row)));

  const codes = rows.map((row) => row.code.trim()).filter(Boolean);
  const duplicates = codes.filter((code, i) => codes.indexOf(code) !== i);

  return (
    <>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{codeLabel}</TableCell>
            <TableCell>{nameLabel}</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow key={i}>
              <TableCell>
                <TextField
                  error={duplicates.includes(row.code.trim())}
                  fullWidth
                  label={codeLabel}
                  onChange={(e) => setRowField(i, 'code', e.target.value)}
                  placeholder={codePlaceholder}
                  required
                  value={row.code}
                  variant="standard"
                />
              </TableCell>
              <TableCell>
                <TextField
                  fullWidth
                  label={nameLabel}
                  onChange={(e) => setRowField(i, 'name', e.target.value)}
                  placeholder={namePlaceholder}
                  required
                  value={row.name}
                  variant="standard"
                />
              </TableCell>
              <TableCell>
                <IconButton
                  aria-label={`Remove ${codeLabel} row ${i + 1}`}
                  onClick={() => save(rows.filter((_, index) => index !== i))}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {duplicates.length > 0 && (
        <FormHelperText error>
          Each code can only be mapped once. The last row wins: {[...new Set(duplicates)].join(', ')}
        </FormHelperText>
      )}
      <Button
        onClick={() => save([...rows, { code: '', name: '' }])}
        startIcon={<AddIcon />}
        sx={{ marginTop: 1 }}
        variant="outlined"
      >
        Add row
      </Button>
    </>
  );
};
